<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({ path: '/' })">首页</span>
        <span>></span>
        <span>购买记录</span>
        <span>></span>
        <span>{{ title }}</span>
        <span v-if="invoice">></span>
        <!-- <span v-if="invoice">开票</span> -->
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="top-nav">
            <ul>
              <li
                v-for="(item, i) in navList"
                :key="i"
                :class="i == isActive ? 'actives' : ''"
                @click="change(i, item.title)"
              >
                {{ item.title }}
              </li>
            </ul>
            <!-- <el-button v-if="!invoice" @click="invoiceBtn">开票</el-button>
            <el-button v-else @click="invoiceBtn">取消</el-button> -->
          </div>
          <div class="single" v-if="isShow">
            <div class="single-info">
              <ul>
                <li v-for="(item, i) in singleList" :key="i">
                  <div
                    class="checkbox"
                    v-if="invoice"
                    @click="checkout(item, i)"
                  >
                    <img
                      src="@/assets/img/check_box.png"
                      alt
                      v-if="invoiceList.indexOf(item) == -1"
                    />
                    <img src="@/assets/img/check_box1.png" alt v-else />
                  </div>
                  <div
                    class="img"
                    v-if="singleList.length > 0 && isActive == 1"
                  >
                    <img :src="item.subject.cover_url" alt />
                  </div>
                  <div
                    class="img"
                    v-if="
                      singleList.length > 0 &&
                        isActive == 2 &&
                        item.type == 'audio_serie' &&
                        item.audio
                    "
                  >
                    <img :src="item.audio.cover_url" alt />
                  </div>
                  <div
                    class="img"
                    v-if="
                      singleList.length > 0 &&
                        isActive == 2 &&
                        item.type == 'audio_article' &&
                        item.article
                    "
                  >
                    <img :src="item.article.cover_url" alt />
                  </div>

                  <div class="info">
                    <h4 v-if="typeName == 'subscribe'">{{ item.title }}</h4>
                    <!-- 订阅 -->
                    <h4 v-if="typeName == 'subject'">
                      {{ item.subject.name }}
                    </h4>
                    <!-- 单行本 -->
                    <h4 v-if="item.type == 'audio_serie'">
                      {{ item.audio.name }}
                    </h4>
                    <!-- 音频栏目 -->
                    <h4 v-if="item.type == 'audio_article'">
                      {{ item.article.title }}
                    </h4>
                    <!-- 音频文章 -->
                    <!-- <div
                      v-if="isActive == 2 && singleList.length > 0 && item.type == 'audio_serie' && item.audio"
                    >来源于: {{item.audio.name}}</div> -->
                    <div
                      v-if="
                        isActive == 2 &&
                          singleList.length > 0 &&
                          item.type == 'audio_article' &&
                          item.article
                      "
                    >
                      来源于: {{ item.article.audio_title }}
                    </div>
                    <!-- 音频文章 -->
                    <div v-if="isActive == 0">
                      有效期 {{ item.begin_date | timePointfilters }} -
                      {{ item.end_date | timePointfilters }}
                    </div>
                    <div>{{ item.created_at | timeAllfilters }}</div>
                    <p>
                      <span>￥</span>
                      {{ item.price }}
                    </p>
                  </div>
                  <el-button
                    v-if="item.is_bill == true"
                    @click="voiceDetail(item)"
                    >已申请</el-button
                  >
                  <!-- <el-button v-if="item.status ==2" class="applying">申请中</el-button> -->
                </li>
              </ul>
              <div
                v-if="this.singleList.length == 0"
                style="text-align: center;line-height: 300px;font-size: 18px"
              >
                暂无信息
              </div>
            </div>
            <div class="totle" v-if="invoice && this.singleList.length > 0">
              <div @click="checkoutAll">
                <img
                  src="@/assets/img/check_box.png"
                  alt
                  style="width:25px"
                  v-if="!showAll"
                />
                <img
                  src="@/assets/img/check_box1.png"
                  alt
                  style="width:25px"
                  v-else
                />
                <span>全选</span>
              </div>
              <div>
                <div>
                  数量:
                  <span>{{ totleNum }}</span
                  >,
                </div>
                <div>
                  共
                  <span>{{ totleMoney }}</span
                  >元
                </div>
              </div>
              <el-button class="next" @click="next">下一步</el-button>
            </div>
          </div>
          <div v-else>
            <div class="buy-record">
              <!-- 暂时不用 -->
              <!-- <div class="img">
                <img :src="img" alt />
              </div>-->
              <div>
                <p>
                  发票金额:
                  <span>￥{{ totleMoney }}</span>
                </p>
                <div>
                  共计
                  <span>{{ nameList[0] }}</span> 等
                  <span>{{ nameList.length }}</span
                  >个选项
                </div>
              </div>
            </div>
            <div class="invoiceInfo">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="name">
                      <p>发票抬头</p>
                      <el-input
                        v-model="ruleForm.name"
                        placeholder="请输入发票抬头"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10" class="right">
                    <el-form-item prop="duty">
                      <p>税号</p>
                      <el-input
                        v-model="ruleForm.duty"
                        placeholder="请输入税号（个人可不填）"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="contacts">
                      <p>联系人</p>
                      <el-input
                        v-model="ruleForm.contacts"
                        placeholder="请输入联系人姓名"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10" class="right">
                    <el-form-item prop="address">
                      <p>邮寄地址</p>
                      <el-input
                        v-model="ruleForm.address"
                        placeholder="请输入邮寄地址"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="phone">
                      <p>联系电话</p>
                      <el-input
                        v-model="ruleForm.phone"
                        placeholder="请输入联系电话"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item style="margin-bottom:0;margin-top: 83px;">
                  <el-button type="primary" @click="submitForm('ruleForm')"
                    >提交申请</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="content-r">
          <DropDownMenu></DropDownMenu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DropDownMenu from "@/components/dropDownMenu";
import {
  getPurchasesList,
  getDrawBill,
  getVoiceDetailList
} from "@/api/system";
import { getTdkList} from "@/api/tdk";

export default {
  components: {
    DropDownMenu
  },
  data() {
    return {
      title: "单行本",
      isActive: 0,
      navList: [{ title: "订阅" }, { title: "单行本" }, { title: "音频" }],
      list: [],
      // 单行本列表
      singleList: [],
      isInvoice: true,
      invoice: false, //复选框
      totleNum: 0,
      totleMoney: 0,
      isShow: true,
      nameList: [],
      ruleForm: {
        name: "",
        duty: "",
        contacts: "",
        address: "",
        phone: "",
        account: ""
      },
      rules: {
        name: [{ required: true, message: "请输入发票抬头", trigger: "blur" }],
        contacts: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入邮寄地址", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号码"
          }
        ],
        account: [
          { required: true, message: "请输入登陆账号", trigger: "blur" }
        ]
      },
      params: {
        page: 1,
        per: 6
      },
      // 开票列表
      invoiceList: [],
      showAll: false,
      finishInvoice: false, //完成开票
      finishList: [],
      typeName: ""
    };
  },
  methods: {
    getList() {
      getPurchasesList(this.params).then(res => {
        this.list = res.data.data;
        for (var i in res.data.data) {
          if (this.isActive == 0) {
            if (res.data.data[i].order_type == "subscribe") {
              this.singleList = res.data.data[i].order;
              this.typeName = res.data.data[i].order_type;
            } else if (this.isActive == 1) {
              if (res.data.data[i].order_type == "subject") {
                this.singleList = res.data.data[i].order;
                this.typeName = res.data.data[i].order_type;
              }
            } else if (this.isActive == 2) {
              if (res.data.data[i].order_type == "audio") {
                this.singleList = res.data.data[i].order;
                this.typeName = res.data.data[i].order_type;
              }
            }
          }
        }
      });
    },
    change(flag, title) {
      this.isActive = flag;
      this.title = title;
      this.invoice = false;
      this.isShow = true;
      // 清空数据
      this.invoiceList = [];
      this.totleNum = 0;
      this.totleMoney = 0;
      for (var i in this.list) {
        if (flag == 0) {
          if (this.list[i].order_type == "subscribe") {
            //订阅会员
            this.singleList = this.list[i].order;
            this.typeName = this.list[i].order_type;
          }
        } else if (flag == 1) {
          // 单行本
          if (this.list[i].order_type == "subject") {
            this.singleList = this.list[i].order;
            this.typeName = this.list[i].order_type;
          }
        } else if (flag == 2) {
          // 音频
          if (this.list[i].order_type == "audio") {
            this.singleList = this.list[i].order;
            this.typeName = this.list[i].order_type;
          }
        }
      }
    },
    // 全选
    checkoutAll() {
      this.showAll = !this.showAll;
      if (this.showAll) {
        for (var i in this.singleList) {
          if (this.invoiceList.indexOf(this.singleList[i]) === -1) {
            this.invoiceList.push(this.singleList[i]);
            this.totleNum = this.singleList.length;
            this.totleMoney =
              this.totleMoney + Number(this.singleList[i].price);
          }
        }
      } else {
        this.invoiceList = [];
        this.totleNum = 0;
        this.totleMoney = 0;
      }
    },
    // 选择
    checkout(item) {
      let ind = this.invoiceList.indexOf(item);
      if (ind === -1) {
        this.invoiceList.push(item);
        this.totleNum++;
        this.totleMoney = this.totleMoney + Number(item.price);
      } else {
        this.invoiceList.splice(ind, 1);
        this.totleNum--;
        this.totleMoney = this.totleMoney - Number(item.price);
      }
      if (this.singleList.length == this.invoiceList.length) {
        this.showAll = true;
      } else {
        this.showAll = false;
      }
    },
    // 开票
    invoiceBtn() {
      if (this.invoice == false) {
        this.isInvoice = true;
        this.invoice = true;
      } else {
        this.isInvoice = false;
        this.invoice = false;
      }
      if (this.isShow == false) {
        this.isShow = true;
      }
      var newArray = [];
      // 筛选未开票信息
      for (var i in this.singleList) {
        if (this.singleList[i].is_bill == false) {
          newArray.push(this.singleList[i]);
        }
      }
      this.singleList = newArray;
    },
    // 下一步
    next() {
      if (this.invoiceList.length > 0) {
        this.isShow = false;
        for (var i in this.invoiceList) {
          this.nameList.push(this.invoiceList[i].title);
        }
      } else {
        this.$message.error("请选择要开票会员");
      }
    },
    // 提交申请
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var params = {
            type: "", //申请类型（audio音频，vip订阅，subject单行本）
            order_num: "", //订单id,多个id用逗号隔开
            name_type: "company", //抬头类型（personal个人，company企业）
            tax_num: this.ruleForm.duty, //税号
            name: this.ruleForm.name, //抬头
            ship_address: this.ruleForm.address, //收件地址
            ship_phone: this.ruleForm.phone, //收件电话
            amount: "", //开票金额 （多个金额用逗号隔开，顺序必须与id一致）
            drawer: this.ruleForm.contacts //联系人
          };
          if (this.isActive == 0) {
            params.type = "vip";
          } else if (this.isActive == 1) {
            params.type = "subject";
          } else if (this.isActive == 2) {
            params.type = "audio";
          }
          var idArray = [];
          var priceArray = [];
          for (var i in this.invoiceList) {
            idArray.push(this.invoiceList[i].id);
            priceArray.push(this.invoiceList[i].price);
          }
          params.order_num = idArray.join(",");
          params.amount = priceArray.join(",");
          getDrawBill(params)
            .then(res => {
              this.$message.success(res.data.message);
              location.reload();
            })
            .catch(error => {
              this.$message.error("申请开票失败");
            });
        } else {
          return false;
        }
      });
    },
    voiceDetail(item) {
      this.$router.push({
        name: "voice_detail",
        params: { id: item.id, title: this.title, isActive: this.isActive }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    if (this.$route.params.isActive != undefined) {
      this.title = this.$route.params.title;
      this.isActive = this.$route.params.isActive;
    }
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.content-l {
  min-height: 800px;
}
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.top-nav {
  display: flex;
  background: #ffffff;
  justify-content: space-between;
  line-height: 50px;
  align-items: center;
  padding: 0 30px;
  ul {
    display: flex;
    li {
      font-size: 16px;
      margin-right: 50px;
      color: #999999;
      cursor: pointer;
    }
    .actives {
      color: #0091ff;
      border-bottom: 4px solid;
    }
  }
  .el-button {
    border-radius: 15px;
    background: #0091ff;
    color: #ffffff;
    height: 30px;
    width: 80px;
    padding: 0;
    cursor: pointer;
  }
}
.single {
  background: #ffffff;
  margin: 30px 0;
  .single-info {
    border-bottom: 1px solid #eeeeee;
    padding: 30px;
    ul {
      li {
        display: flex;
        margin-bottom: 30px;
        position: relative;
        .checkbox {
          align-items: center;
          transform: translate(0px, 40%);
          margin-right: 30px;
          width: 25px;
          img {
            width: 100%;
          }
        }
        .img {
          width: 20%;
          margin-right: 30px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .info {
          width: 69%;
          padding-top: 10px;
          position: relative;
          h4 {
            font-size: 20px;
            font-weight: 400;
            margin-bottom: 20px;
          }
          div {
            font-size: 14px;
            color: #999999;
            line-height: 24px;
            span {
              margin-right: 10px;
            }
          }
          p {
            color: #ff0000;
            font-size: 18px;
            margin-top: 10px;
            span {
              font-size: 12px;
              margin-right: -4px;
            }
          }
        }
        .el-button {
          width: 64px;
          color: #666666;
          height: 25px;
          border-radius: 13px;
          margin-top: 14px;
          background: #f5f5f5;
          padding: 0;
          position: absolute;
          right: 0;
        }
        .applying {
          background: #ffffff;
        }
        .el-button:hover {
          border-color: #dcdfe6;
        }
      }
    }
  }
  .totle {
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 50px;
    font-size: 16px;
    div {
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    div:nth-child(2) {
      div {
        display: inline;
        margin-right: 4px;
        span {
          color: #ff0000;
        }
      }
    }
    .el-button {
      background: #0091ff;
      color: #ffffff;
      border-radius: 15px;
      width: 80px;
      height: 30px;
      padding: 0;
    }
  }
}
.buy-record {
  background: #ffffff;
  margin-top: 30px;
  padding: 30px;
  display: flex;
  .img {
    width: 16%;
    max-width: 140px;
    max-height: 140px;
    margin-right: 30px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  div {
    p {
      font-size: 20px;
      color: #999999;
      margin-bottom: 30px;
      margin-top: 20px;
      span {
        color: #ff0000;
      }
    }
  }
}
.invoiceInfo {
  background: #ffffff;
  padding: 30px;
  margin: 30px 0;
  .right {
    float: right;
  }
  .el-col-10 {
    width: 44% !important;
  }
  >>> .el-form-item__content {
    margin-left: 0px !important;
    margin-top: 10px;
    p {
      line-height: 20px;
      font-size: 16px;
    }
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #dcdfe6;
      border-radius: 0;
      padding: 0;
    }
  }
  >>> input::-webkit-input-placeholder {
    color: #999999;
    font-size: 14px;
  }

  >>> .el-button--primary {
    border-radius: 18px !important;
    padding: 10px 16px !important;
  }
  >>> .el-button--primary:hover {
    background: #409eff;
    border-color: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/buyRecords/singleCopy.vue